import React from 'react';
import styles from '../styles/Home.module.css';

const Home: React.FC = () => {
  return (
    <>
      <title>Welcome - monteX2</title>
      <div className={styles.container}>
        <div className={styles.homeGrid}>
          <div className={styles.welcomeSection}>
            <div className={styles.title} style={{ width: '100%', textAlign: 'left' }}>
              Welcome to
            </div>
            <div>
              <div>
                <span className="logo" style={{ fontSize: '6rem', lineHeight: '1.1' }}>
                  <span className="monteText">monte</span>
                  <span className="x2Text">X2</span>
                </span>
              </div>
            </div>
            <p className={styles.phonetic}>[mɔntə ˈkrɪsto]</p>
            <p className={styles.subtitle} style={{ fontSize: '1.66rem', fontWeight: 'bold', width: '100%', textAlign: 'left' }}>
              This is a private site. By invitation only.
            </p>
            <p className={styles.description} style={{ width: '100%', textAlign: 'left' }}>
              If you are a member, please log in and enjoy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
